var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never", bordered: false } },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 这里是本门店负责团长的签约合同。签约在腾讯电子签完成，平台确认后上传签好的合同 PDF，上传后即可在此查看。 "
            ),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, size: "small", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "序号",
                  width: "70",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "contractName",
                  label: "合同名称",
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "签署人", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(row.signerName || "-") +
                            " " +
                            _vm._s(row.signerMobile || "")
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "el-table-column",
                { attrs: { label: "状态", width: "90" } },
                [
                  [
                    _c("el-tag", { attrs: { size: "mini", type: "success" } }, [
                      _vm._v("已完成"),
                    ]),
                  ],
                ],
                2
              ),
              _c("el-table-column", {
                attrs: {
                  prop: "finishTime",
                  label: "签约时间",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "100", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.preview(row)
                              },
                            },
                          },
                          [_vm._v("查看合同")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.previewTitle,
            visible: _vm.previewVisible,
            width: "80%",
            top: "4vh",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
            closed: _vm.revoke,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.previewLoading,
                  expression: "previewLoading",
                },
              ],
              staticClass: "pdf-box",
            },
            [
              _vm.blobUrl
                ? _c("iframe", {
                    staticClass: "pdf-frame",
                    attrs: { src: _vm.blobUrl },
                  })
                : _vm.previewError
                ? _c("div", { staticClass: "pdf-error" }, [
                    _vm._v(_vm._s(_vm.previewError)),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.openNew } },
                [_vm._v("新窗口打开")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }